// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import AdminRoute from './components/AdminRoute';
import ManageChallenges from './components/ManageChallenges';
import Leaderboard from './components/Leaderboard';
import Logout from './components/Logout';
import EditChallenge from './components/EditChallenge';
import Marketplace from './components/Marketplace';
import ManageProducts from './components/ManageProducts';
import AdminPurchases from './components/AdminPurchases';

// Bolt.new components
import Header from './components/Bolt/Header';
import Hero from './components/Bolt/Hero';
import ChallengeSection from './components/Bolt/ChallengeSection';
import RewardsSection from './components/Bolt/RewardsSection';
import ProfileSection from './components/Bolt/ProfileSection';
import ParticlesBackground from './components/Bolt/ParticlesBackground';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-white to-[#0dceda]/5">
        <ParticlesBackground />
        <Header />
        <main className="pt-16">
          <Routes>
            {/* Home includes Bolt.new UI */}
            <Route
              path="/"
              element={
                <>
                  <Hero />
                  <ChallengeSection />
                  <RewardsSection />
                  <ProfileSection />
                </>
              }
            />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/login" element={<Login />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/marketplace" element={<Marketplace />} />
            {/* Admin routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route 
              path="/admin" 
              element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              } 
            />
            <Route 
              path="/admin/challenges" 
              element={
                <AdminRoute>
                  <ManageChallenges />
                </AdminRoute>
              } 
            />
            <Route path="/admin/challenge/edit/:id" element={<EditChallenge />} />
            <Route 
              path="/admin/products" 
              element={
                <AdminRoute>
                  <ManageProducts />
                </AdminRoute>
              } 
            />
            <Route 
              path="/admin/purchases" 
              element={
                <AdminRoute>
                  <AdminPurchases />
                </AdminRoute>
              } 
            />
            {/* If no matching route, redirect to Home */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;